function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.535 4L18.39 5.154l3.484 3.432H4.738v1.603h17.136l-3.483 3.433 1.144 1.153L25 9.387 19.535 4zM9.467 15.225L4 20.613 9.467 26l1.144-1.153-3.483-3.433h17.136v-1.603H7.127l3.484-3.433-1.144-1.153z"
});
function SvgExchange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _ref);
}
export default SvgExchange;